module.exports = __webpack_public_path__ + "static/img/Body-12.3d6dc228.jpg";